import React from "react";

const EditableParagraph = (props) => {
  return (
    <pre
      className={`pl-0 pt-0 ${props.className} ${props.disabled ? "contenteditable-paragraph-readonly" : "contenteditable-paragraph"
        } ${!props.disabled && (!props.text || props.text?.length == 0)
          ? "empty"
          : ""
        }`}
      contenteditable={props.disabled ? "false" : "true"}
      plaintext-only="true"
      onBlur={props.onBlur}
      onMouseOver={props.onHover}
      onMouseOut={props.onBlur}
      dangerouslySetInnerHTML={{ __html: props.text }}
    // dangerouslySetInnerHTML={{ __html: props.text.replace(/\n/,"<br />") }}
    />
  );
};

export default EditableParagraph;
